import React from "react";
import { useNavigate } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { useS } from "../../lib/simple";

export function NextCard() {
  const { s } = useS();
  const nav = useNavigate();
  return (
    <div className="beam p-[1px]" data-testid="home-next-card">
      <div className="rounded-[1.2rem] bg-[var(--lb-card)] p-5 sm:p-6">
        <p className="inline-flex items-center gap-2 text-xs font-bold tracking-wide text-neon uppercase"><Compass size={15} /> {s("next_title")}</p>
        <p className="text-sm sm:text-base text-[hsl(var(--muted-foreground))] mt-3">{s("next_sub")}</p>
        <Button onClick={() => nav("/app/start?edit=1")} data-testid="home-next-cta" className="w-full sm:w-auto sm:px-8 mt-5 rounded-full h-14 bg-gradient-to-r from-primary to-neon text-white lb-glow-btn font-semibold text-base">
          {s("next_cta")} <ArrowRight size={18} className="ml-1.5" />
        </Button>
      </div>
    </div>
  );
}
